<template>
  <v-card class="media-card" :class="{ selected }" variant="flat" @click="$emit('toggle', item)">
    <v-img :src="item.image_url" :alt="item.title" aspect-ratio="0.72" cover />
    <div class="media-card__body">
      <div class="media-card__title">{{ item.title }}</div>
      <div class="tag-row">
        <v-chip v-for="tag in item.tags || []" :key="tag" size="x-small" variant="tonal">{{ tag }}</v-chip>
      </div>
    </div>
  </v-card>
</template>

<script setup>
defineProps({ item: { type: Object, required: true }, selected: Boolean });
defineEmits(['toggle']);
</script>
